import { useLocation, useNavigate } from 'react-router-dom';
import Images from './Images';
import { cn } from '@/utils';
const BottomTabs = () => {
  const navigate = useNavigate();
  const tabs = [
    { label: 'Sports', icon: '/home/sport.svg', path: '/live' },
    { label: '', icon: '/home/home.svg', path: '/', center: true },
    { label: 'Quiz', icon: '/home/chat.svg', path: '/quiz' },
  ];
  const { pathname } = useLocation();
  return (
    <nav
      className="fixed  bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-30  bg-black border-t border-primary-border
                      flex justify-around items-center px-4 h-16"
    >
      {tabs.map((tab) => {
        const isActive = pathname === tab.path;
        const isCenter = tab.center;
        return (
          <div
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={cn(
              'flex items-center mx-2 justify-start gap-3 p-1.5   rounded-full gradient-box transition-all duration-300',
              isActive ? '!bg-btn-gradient2 text-white' : 'bg-transparent',
              isCenter ? 'rounded-full' : 'w-[170px]'
            )}
          >
            <div className="bg-primary-tabg p-2 rounded-full">
              <Images src={tab.icon} alt={tab.label} className={isCenter ? 'w-10' : ''} />
            </div>
            {tab.label && <span className={`text-13 ${isActive ? '' : ''}`}>{tab.label}</span>}
          </div>
        );
      })}
    </nav>
  );
};

export default BottomTabs;
